import type { AutoSummaryTabProps } from '../AutoSummaryTab.types';
import type { AutoSummaryData } from './useAutoSummaryData.types';

import { SUMMARY_SENTENCE_BREAK_LIMIT } from '../AutoSummaryTab.constants';
import * as constants from 'constants/DocumentConstants';

import { useMemo } from 'react';

export const useAutoSummaryData = ({ props }: { props: AutoSummaryTabProps }): AutoSummaryData => {
  const formattedData: AutoSummaryData['formattedData'] = useMemo(() => {
    const summaries = {
      [constants.SUMMARY_TYPE.LONG]: [] as string[],
      [constants.SUMMARY_TYPE.SHORT]: [] as string[]
    };

    props.document.summaries.forEach(summary => {
      const existingSummaries = summaries[summary.type] || [];
      const currentSummaries = summary.summary_sentences || [];

      summaries[summary.type] = [...existingSummaries, ...currentSummaries];
    });

    const oldSummaries = props.document?.summaries?.[0].summary_sentences;
    const isUsingLineBreaks = oldSummaries.some(sentence => sentence.includes('\n\n'));
    const formattedOldSummary = isUsingLineBreaks
      ? oldSummaries
      : oldSummaries.map(sentence =>
          sentence.length > SUMMARY_SENTENCE_BREAK_LIMIT
            ? sentence.replaceAll(/(?<=[.!?])\s+/g, '\n\n')
            : sentence
        );

    return {
      longSummary: summaries[constants.SUMMARY_TYPE.LONG].join(' '),
      shortSummary: summaries[constants.SUMMARY_TYPE.SHORT].join(' '),
      oldSummary: formattedOldSummary
    };
  }, [props.document.summaries]);

  return { formattedData };
};
